import RecipeListingPage from './RecipeListingPage';

export default RecipeListingPage;
